import { render } from "./index.vue?vue&type=template&id=39b4fd83"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=39b4fd83&lang=less"
script.render = render

export default script